import Vue from 'vue';
import VueI18n from 'vue-i18n';

import ko from './ko-KR.json';
import zhTW from './zh-TW.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'ko',
  fallbackLocale: 'ko',
  messages: {
    ko,
    'zh-tw': zhTW,
  },
});



// WEBPACK FOOTER //
// ./src/i18n/index.js